/* eslint max-classes-per-file: 0 */

import {
  PublicationStorageFile as Data,
  PublicationStorageFileCollection as Collection,
} from '@/typings/api/Publication'

import { Fabric } from '@/store/createCrudModule'
import { PublicationsStorageFilesAdapter as Adapter } from './PublicationsStorageFilesAdapter'


export const fabric = Fabric<Data, Collection>()

type S = PublicationsStorageFilesState
type G = PublicationsStorageFilesGetters
type M = PublicationsStorageFilesMutations
type A = PublicationsStorageFilesActions


export class PublicationsStorageFilesState extends fabric.State {
}

export class PublicationsStorageFilesGetters extends fabric.Getters<S> {
}

export class PublicationsStorageFilesMutations extends fabric.Mutations<S> {
}

export class PublicationsStorageFilesActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new Adapter();

  protected readonly idName = 'id';

  public deleteAll(params: Record<string, unknown>) {
    return this.adapter.api.deleteAll(params)
  }
}
